<template>
  <div class="tabs is-centered is-boxed">
    <ul>
      <li v-for="(location, index) in navigationTabs" :key="location.name"
          :class="{ 'is-active': index == navigationTabIndex }">
        <a v-on:click="onTabSelected(index)">
          <span class="icon is-small"
            :class="{ 'is-active': index == navigationTabIndex }">
            <i class="fas fa-city" aria-hidden="true"></i>
          </span>
          <span>{{ location.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import constants from '../../constants'
import { mapGetters } from 'vuex'

export default {
  name: 'Tabs',
  computed: {
    ...mapGetters([
      'navigationTabs',
      'navigationTabIndex',
    ])
  },
  methods: {
    onTabSelected(tabIndex) {
      // Update store and store in local storage to survive browser sessions.
      this.$store.commit('setNavigationTabIndex', tabIndex)
      localStorage.setItem(constants.NAV_ACTIVE_TAB, tabIndex)
    }
  }
}
</script>

<style scoped>
span.icon {
  display: none;
  margin-right: 12px !important;
  margin-top: -10px;
}
span.is-active {
  display: block;
}
</style>
